import { BrowserCacheLocation, Configuration, LogLevel, RedirectRequest, SilentRequest } from "@azure/msal-browser";

const clientId =
  process.env.REACT_APP_MSAL_CLIENT_ID || "ogc-audit-client";

const tenantId =
  process.env.REACT_APP_MSAL_TENANT_ID ||
  "common";

const authority =`https://login.microsoftonline.com/${tenantId}`;

const redirectUri =
  process.env.REACT_APP_MSAL_REDIRECT_URI ||
  (typeof window !== "undefined" ? window.location.origin : "/");

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    allowRedirectInIframe: true,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

const customScopes = process.env.REACT_APP_MSAL_SCOPES
  ? process.env.REACT_APP_MSAL_SCOPES.split(" ")
  : [];

export const loginRequest: RedirectRequest = {
  scopes: ["openid", "profile", "email", ...customScopes],
};

const silentRedirectUri =
  typeof window !== "undefined"
    ? `${window.location.origin}/blank.html`
    : "/blank.html";

export const tokenRequest: SilentRequest = {
  scopes: ["openid", "profile", "email", ...customScopes],
  redirectUri: silentRedirectUri,
};
